import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';


const fetchVesselServiceTypes = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/data/readVesselServiceTypes`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch vessel service types');
  }

  return response.json();
};


const useReadVesselServiceTypes = () => {
  const { token } = useContext(AuthContext); 

  return useQuery('vesselServiceTypes', () => fetchVesselServiceTypes(token)); 
};

export default useReadVesselServiceTypes;
